import {
  StyledInputWrapper,
  StyledInputLabel,
  StyledDropdownField,
  StyledFormItemField,
} from "./style";
import type { DropdownFieldProps } from "./interfaces";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { TagRender } from "./TagsDropdownField";

export const DropdownField = (props: DropdownFieldProps) => {
  const { t } = useTranslation();

  const [selectedValue, setSelectedValue] = useState(props.value);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const handleChange = (value: string | number | unknown) => {
    if (typeof value === "string" || typeof value === "number") {
      setSelectedValue(value);
    }

    if (props.onChange) {
      props.onChange(value);
    }
  };

  return (
    <StyledInputWrapper style={props.style} hidden={props.hidden}>
      {props.label ? <StyledInputLabel>{props.label}</StyledInputLabel> : null}
      <StyledFormItemField name={props.name} rules={props.rules}>
        <StyledDropdownField
          onBlur={props.onBlur}
          onSearch={props.onSearch}
          allowClear
          options={props.options}
          placeholder={
            props.isEditable ? props.placeholder || t("Select") : t("Empty")
          }
          isEditable={props.isEditable}
          suffixIcon={props.isEditable ? undefined : null}
          value={selectedValue}
          onChange={handleChange}
          mode={props.mode}
          filterOption={(input, option) =>
            (option?.label as string).includes(input)
          }
          tagRender={(tagProps) =>
            TagRender ? (
              TagRender({ ...tagProps, closable: !!props.isEditable })
            ) : (
              <></>
            )
          }
        />
      </StyledFormItemField>
    </StyledInputWrapper>
  );
};
